(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-additions-components/assets/javascripts/weeks.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-additions-components/assets/javascripts/weeks.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  RadioButton = _svs$ui$reactForm.RadioButton,
  Fieldset = _svs$ui$reactForm.Fieldset,
  Form = _svs$ui$reactForm.Form;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const actions = svs.components.tipsen.engine.actions;
const selectCurrentWeek = svs.components.tipsen.engine.selectors.couponSelectors.selectCurrentWeek;
const selectWeeks = svs.components.tipsen.engine.selectors.engineSelectors.selectWeeks;
const BaseAddons = svs.components.tipsen.baseAddons.BaseAddons;

const Weeks = _ref => {
  let title = _ref.title,
    icon = _ref.icon,
    description = _ref.description,
    legend = _ref.legend,
    presentableWeek = _ref.presentableWeek;
  const dispatch = useDispatch();
  const weeks = useSelector(selectWeeks);
  const couponId = useCouponId();
  const currentWeek = useSelector(state => selectCurrentWeek(state, couponId));
  return React.createElement(BaseAddons, {
    description: description,
    icon: icon,
    id: "weeks",
    title: title
  }, React.createElement(Form, {
    className: "tipsen-addition-form"
  }, React.createElement(Fieldset, null, React.createElement("legend", {
    className: "sr-only"
  }, legend), React.createElement(ControlGroup, null, React.createElement(RadioGroup, {
    size: "200"
  }, weeks.map((week, index) => {
    const checked = currentWeek === week;
    return React.createElement(RadioButton, {
      "aria-checked": checked,
      checked: checked,
      className: checked ? 'f-bold' : '',
      key: week,
      onChange: () => dispatch(actions.selectWeek({
        couponId,
        week: index
      })),
      tabIndex: checked ? 0 : -1,
      value: week
    }, presentableWeek(week));
  }))))));
};
setGlobal('svs.components.tipsen.couponAdditionsComponents.Weeks', Weeks);

 })(window);